import * as React from "react";

const LinkArrow: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195.1 195.1" preserveAspectRatio="none">
            <path
                fill="currentColor"
                d="m97.8 66 27.1 27.3H53.7v8.6h71.1l-27 27.2 6.1 6.1 36.2-36.4 1.3-1.1-37.5-37.8z"
            />
        </svg>
    );
};

export default React.memo(LinkArrow);
